import BUTTON from '../../../DOM/button/BUTTON.js';
import Switchable from '../../../../interface/Switchable.js';
import { makeAttrStruct } from '../../../../enums/ModelAttr.js';
import { makeStruct } from '../../../../enums/MODELS.js';
import { makeDataStruct } from '../../../../enums/ModelData.js';
// Model Structure
export const switchbuttonAttr = makeAttrStruct([
    ['name'],
    ['title'],
    ['class'],
    ['disabled']
]);
export const switchbuttonData = makeDataStruct([
    ['text', ''],
    ['icon']
]);
export const switchModel = makeStruct([
    ['attributes', switchbuttonAttr],
    ['data', switchbuttonData]
]);
// Simplified Model
export function switchbutton(text, icon, name, title, className, disabled) {
    return {
        attributes: switchbuttonAttr(name, title, className, disabled),
        data: switchbuttonData(text, icon)
    };
}
/** Button that can be switched on or off */
export default class SWITCHBUTTON extends BUTTON {
    constructor(node, model) {
        super(node, model);
        this.implement(new Switchable(this));
        this.addClass('switch');
    }
}
